export default String.raw`
<defs>
    <rect id="path-1" x="0" y="0" width="1042" height="136"></rect>
</defs>
<g id="06.-Lista-towarów" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="opis-copy" transform="translate(1.000000, 1.000000)">
        <rect id="Rectangle" class="bgColor" x="-19" y="-20" width="1083" height="246"></rect>
        <rect id="Rectangle" class="lightBorderColor--stroke" x="0" y="0" width="1041" height="204"></rect>
        <rect id="path-2" x="0" y="0" width="1040" height="136"></rect>
        <g id="pexels-cottonbro-6153367" transform="translate(0.000000, 68.000000)">
            <mask id="mask-2" fill="white">
                <use xlink:href="#path-1"></use>
            </mask>
            <mask id="mask-3" fill="white">
                <use xlink:href="#path-2"></use>
            </mask>
            <use id="Mask" class="bgColor" xlink:href="#path-1"></use>
            <image id="pexels-ingo-joseph-609771" mask="url(#mask-3)" x="0" y="-391.806479" width="1042" height="1042.29943" href="./img/previewElements/categoryDescriptionDesktop_1.png"></image>
        </g>
        <text id="Obuwie-męskie" class="primaryColorFont" font-family="Roboto-Bold, Roboto" font-size="19" font-weight="bold">
            <tspan x="19" y="44">Telefony i zegarki</tspan>
        </text>
        <g transform="translate(1008, 2)">
            <use class="primaryColorFont primaryColorFont--stroke" xlink:href="#angle-up" width="48" height="48" transform="scale(10)"></use>
        </g>
        <rect id="Rectangle" fill-opacity="0.9" fill="#FFFFFF" x="18" y="86" width="800" height="90"></rect>
        <text id="Buty-dla-prawdziwych" font-family="Roboto-Regular, Roboto" font-size="14" font-weight="normal" line-spacing="19" fill="#000000">
            <tspan x="38" y="116">Statystyczna osoba korzysta z telefonu nawet 4h dziennie. Dlatego wiemy jak ważne jest kupno solidnego</tspan>
            <tspan x="38" y="137">i sprawdzonego smartfona czy smartwatcha. Istniejemy na rynku kilkanaście lat. Doskonale znamy się na sprzęcie </tspan>
            <tspan x="38" y="158">multimedialnym. Nie ryzykuj, kup u nas.</tspan>
        </text>
    </g>
</g>
`;